import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export default function MainLoadingScreen({ sx = {}, loaderSX = {} }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ bgcolor: "common.black", ...sx }}
    >
      <CircularProgress sx={{ color: "primary.main", ...loaderSX }} />
    </Box>
  );
}
